export default {
  shoppingCartView: {
    title: "Panier d'achat",
    agencyProductsSubtitle: "Produits de l'agence",
    boutiqueProductsSubtitle: 'Produits du boutique',
    reservedProductsSubtitle: 'Réservés',
    unavailableLabel: 'Indisponible',
    unavailableHint: 'Retirez ce produit pour continuer',
    unavailableCheckoutBlocked: "Un ou plusieurs produits de votre panier ne sont plus disponibles. Veuillez les retirer pour poursuivre votre commande.",
    removeUnavailable: 'Retirer du panier',
    foreignInventoryTitle: 'Erreur !',
    foreignInventory: "Ce produit provient de l'inventaire d'une autre région et ne peut pas être ajouté à ce panier.",
  },
  shoppingCartEmptyView: {
    infoPar1Span1: 'Ton panier est vide. Si tu as soif, rempli-le en explorant les produits du ',
    infoPar1Span2: 'boutique de Montréal,',
    infoPar1Span3: ' ou ceux de ',
    infoPar1Span4: "l'agence",
    infoPar1Span5: '.',
    infoPar1Span7: ' boutique de Québec',
    infoPar2Span1: 'Psss, tu peux aussi trouver de la ',
    infoPar2Span2: 'nourriture',
    infoPar2Span3: ' pour emporter et une multitude de ',
    infoPar2Span4: 'produits connexes',
    infoPar2Span5: '.',
    infoPar1Span8: '  boutique de Toronto',
  },
  shoppingCartSummaryComponent: {
    summary: 'Sommaire',
    agency: 'Agence',
    agencyFees: "Frais d'agence",
    saqFees: 'Frais SAQ',
    subTotal: 'Payer à la Saq',
    payNow: 'Payer maintenant',
    boutique: 'Boutique',
    tps: 'TPS',
    tvq: 'TVQ',
    total: 'Total',
    toPaySaq: 'À payer à la SAQ (+ tx.)',
    toPayNow: 'Sous-total',
    ctaOrder: 'Commander',
    validation: 'La quantité ajoutée pour ce produit n\'est pas disponible, veuillez retirer le produit ou réduire la quantité.',
    soldOut: 'ce produit est épuisé depuis son ajout au panier et doit être retiré pour poursuivre votre commande.'
  },
  shoppingCartAuthModel: {
    placeOrder: 'Passer la commande',
    guestOrder: 'Commander comme invité',
    register: 'Déjà enregistré ?',
    registerNow: "S'enregistrer",
    signIn: 'Se connecter',
    continue: 'Continuer',
    createAccount: 'Créer un compte'
  }
};
